//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import rightColumnPagesQuery from '~/apollo/queries/pages/right-column-page-slug'

export default {
  mixins: [seo],
  // Nuxt makes _slug optional here (no sibling index.vue), so /site and /SITE
  // would render this page with slug undefined and send Strapi an invalid
  // GraphQL variable (400). 404 instead of querying.
  validate ({ params }) {
    return typeof params.slug === 'string' && params.slug.length > 0
  },
  data () {
    return {
      fetched: false
    }
  },
  apollo: {
    rightColumnPages: {
      query: rightColumnPagesQuery,
      prefetch: true,
      variables () {
        return { slug: this.$route.params.slug }
      },
      // `data` is undefined when the query errored (vue-apollo still calls
      // result()); an unguarded access here throws inside an observable and
      // takes the whole SSR process down.
      result ({ data, loading, networkStatus }) {
        if (data && data.rightColumnPages && data.rightColumnPages.length > 0) {
          this.seoTitle = data.rightColumnPages[0].pageTitle
          this.seoNoindex = !!data.rightColumnPages[0].excludeFromSearchResults
        }
        this.fetched = true
      },
      error (error) {
        console.error('[apollo] ' + this.$route.fullPath + ': ' + (error && error.message))
        this.fetched = true
      }
    }
  }
}
